// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"5001":"student","6390":"student-router","7468":"insertEmbedded"}[chunkId] + ".min.css";
};